<app-companies-nav [activeMenuItem]="'products'"></app-companies-nav>

<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="100">

    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
    <ng-container *ngIf="!isLoading">
      <div style="display: inline-block; cursor: pointer; padding-right: 15px;" (click)="returnBack()">
        <span >◀️ Go back</span>
      </div>


      <button mat-raised-button color="primary" style="margin-right: 10px;" [disabled]="isLoading || !prevNextIds?.prevId" (click)="gotoPrev()">Previous</button>
      <button mat-raised-button style="margin-right: 10px;" color="primary" [disabled]="isLoading || !prevNextIds?.nextId" (click)="gotoNext()">Next</button>

      <button mat-raised-button style="margin-left: 10px;" color="primary" [disabled]="isLoading || !isAdmin()" (click)="goToEdit()"><mat-icon>edit</mat-icon> Edit</button>

    </ng-container>



  </div>
</div>

<div fxLayout="row" *ngIf="product">
  <mat-card class="content-card container-md" fxFlex="100">
    <div fxFlex="50">

      <div style="display: inline-block; padding-right: 20px;">
        <mat-icon *ngIf="!product.logoUrl">add_a_photo</mat-icon>
        <img alt="product logo" *ngIf="product.logoUrl" class="logo" [src]="product.logoUrl">
      </div>
      <div style="display: inline-block">
        <h3 style="margin-bottom: 0">{{ product.name }}</h3>
        <div><small>{{product.shortName}}</small></div>
        <div><small><a routerLink="/companies/{{ product.companyId }}">{{product.companyName}}</a></small></div>
      </div>
    </div>
    <div fxFlex="50" style="text-align: right">

    </div>
  </mat-card>
</div>

<div fxLayout="row" fxLayoutGap="10px" *ngIf="product">

  <mat-card
    class="content-card container-md"
    fxFlex="33"
    *ngIf="product?.restrictToCountriesAsList != null"
    style="background-color: yellow; color: black;"
  >
    <mat-card-content>
      This product is restricted to certain countries
    </mat-card-content>
  </mat-card>

  <mat-card
    class="content-card container-md"
    fxFlex="33"
    *ngIf="product?.productKey != null"
    style="background-color: lightskyblue"
  >
    <mat-card-content>
      The Product Key is {{ product.productKey }}
    </mat-card-content>
  </mat-card>

  <mat-card
    class="content-card container-md"
    fxFlex="33"
    *ngIf="product?.productKey == null"
    style="background-color: red"
  >
    <mat-card-content>
      This product has no product key
    </mat-card-content>
  </mat-card>

  <mat-card
    class="content-card container-md"
    fxFlex="33"
    *ngIf="product?.replacementProductId != null"
    style="background-color: orange"
  >
    <mat-card-content>
      This product has been replaced with product
      <a [routerLink]="'../'+product.replacementProductId">
        {{product.replacementProductId}} - {{product.replacementProduct?.name}}
      </a>
    </mat-card-content>
  </mat-card>

  <mat-card
    class="content-card container-md"
    fxFlex="33"
    *ngIf="product?.primaryProductId != null"
    style="background-color: dodgerblue"
  >
    <mat-card-content>
      This is a secondary product of
      <a [routerLink]="'../'+product.primaryProductId">
        {{product.primaryProductId}} - {{product.primaryProduct?.name}}
      </a>
    </mat-card-content>
  </mat-card>


      <mat-card *ngIf="product?.canOrderAsPrimary === true" class="content-card container-md"
                fxFlex="33"
                style="background-color: #8bc34a">
        <mat-card-content>
          This product can be ordered as a primary card
        </mat-card-content>
      </mat-card>


  <mat-card *ngIf="product?.canOrderAsPrimary === false" class="content-card container-md"
            fxFlex="33"
            style="background-color: yellow">
    <mat-card-content>
      This product can <b>NOT</b> be ordered as a primary card
    </mat-card-content>
  </mat-card>



</div>



<div fxLayout="row" *ngIf="product?.canOrderAsPrimary === false">

</div>



<div fxLayout="row wrap">

  <div fxFlex="50" fxFlex.md="50" fxFlex.sm="100">
    <mat-card class="content-card">
      <mat-card-header>
          <mat-card-title>
              <h5>Product</h5>
          </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="list-item" fxLayout="row" *ngFor="let field of fields ">
          <label fxFlex="35" class="secondary">{{ field.header }}</label>
          <label fxFlex="65" *ngIf="product">{{ field.cell(product) }}</label>
        </div>

        <!-- restrict to countries -->
        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Restrict to countries</label>
          <label fxFlex="65" *ngIf="product">
            <ng-container *ngIf="!product.restrictToCountriesAsList">
              (no restriction)
            </ng-container>
            <ng-container *ngIf="product.restrictToCountriesAsList">
              <div *ngFor="let countryCode of product.restrictToCountriesAsList">
                <flag-icon [country]="countryCode"></flag-icon> {{ countriesByAlpha2[countryCode|uppercase]?.name ?? '??' }}
              </div>
            </ng-container>


          </label>
        </div>



      </mat-card-content>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Logos</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Logo</label>
          <label fxFlex="65" *ngIf="product && logoUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + logoUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + logoUpload.id" />
            </div>
            {{logoUpload.id}} - {{logoUpload.originalFileName}}
          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Img</label>
          <label fxFlex="65" *ngIf="product && imgUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + imgUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + imgUpload.id" />
            </div>
            {{imgUpload.id}} - {{imgUpload.originalFileName}}
          </label>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Images</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>


        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Clean Card Image</label>
          <label fxFlex="65" *ngIf="product && cleanCardImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + cleanCardImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + cleanCardImageUpload.id" />
            </div>
            {{cleanCardImageUpload.id}} - {{cleanCardImageUpload.originalFileName}}
            <small style="color: red;">LEGACY for App version up to 1.0.11 </small>
          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Background Image</label>
          <label fxFlex="65" *ngIf="product && backgroundImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + backgroundImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + backgroundImageUpload.id" />
            </div>
            {{backgroundImageUpload.id}} - {{backgroundImageUpload.originalFileName}}

          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Overlay 1 Image</label>
          <label fxFlex="65" *ngIf="product && overlay1ImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + overlay1ImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + overlay1ImageUpload.id" />
            </div>
            {{overlay1ImageUpload.id}} - {{overlay1ImageUpload.originalFileName}}
          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Overlay 2 Image</label>
          <label fxFlex="65" *ngIf="product && overlay2ImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + overlay2ImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + overlay2ImageUpload.id" />
            </div>
            {{overlay2ImageUpload.id}} - {{overlay2ImageUpload.originalFileName}}
          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Overlay 3 Image</label>
          <label fxFlex="65" *ngIf="product && overlay3ImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + overlay3ImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + overlay3ImageUpload.id" />
            </div>
            {{overlay3ImageUpload.id}} - {{overlay3ImageUpload.originalFileName}}
          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Overlay 4 Image</label>
          <label fxFlex="65" *ngIf="product && overlay4ImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + overlay4ImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + overlay4ImageUpload.id" />
            </div>
            {{overlay4ImageUpload.id}} - {{overlay4ImageUpload.originalFileName}}
          </label>
        </div>



        <div class="text-center mt-2">
          <img style="width: 100%; max-width: 400px;" alt="Card preview" *ngIf="cardPreviewUrl" [src]="cardPreviewUrl">
        </div>



      </mat-card-content>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Virtual-only images</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Clean Card Image</label>
          <label fxFlex="65" *ngIf="product && virtualOnlyBackgroundImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + cleanCardImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + cleanCardImageUpload.id" />
            </div>
            {{virtualOnlyBackgroundImageUpload.id}} - {{virtualOnlyBackgroundImageUpload.originalFileName}}
          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Overlay 1 Image</label>
          <label fxFlex="65" *ngIf="product && virtualOnlyOverlay1ImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + virtualOnlyOverlay1ImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + virtualOnlyOverlay1ImageUpload.id" />
            </div>
            {{virtualOnlyOverlay1ImageUpload.id}} - {{virtualOnlyOverlay1ImageUpload.originalFileName}}
          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Overlay 2 Image</label>
          <label fxFlex="65" *ngIf="product && virtualOnlyOverlay2ImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + virtualOnlyOverlay2ImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + virtualOnlyOverlay2ImageUpload.id" />
            </div>
            {{virtualOnlyOverlay2ImageUpload.id}} - {{virtualOnlyOverlay2ImageUpload.originalFileName}}
          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Overlay 3 Image</label>
          <label fxFlex="65" *ngIf="product && virtualOnlyOverlay3ImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + virtualOnlyOverlay3ImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + virtualOnlyOverlay3ImageUpload.id" />
            </div>
            {{virtualOnlyOverlay3ImageUpload.id}} - {{virtualOnlyOverlay3ImageUpload.originalFileName}}
          </label>
        </div>

        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Overlay 4 Image</label>
          <label fxFlex="65" *ngIf="product && virtualOnlyOverlay4ImageUpload">
            <div style="display: inline-block; width: 100px; height: 60px; text-align: center">
              <img src="{{environment.apiUrl + virtualOnlyOverlay4ImageUpload.fileName}}" style="height: 60px; max-width: 100px" [alt]="'upload-' + virtualOnlyOverlay4ImageUpload.id" />
            </div>
            {{virtualOnlyOverlay4ImageUpload.id}} - {{virtualOnlyOverlay4ImageUpload.originalFileName}}
          </label>
        </div>



        <div class="text-center mt-2">
          <img style="width: 100%; max-width: 400px;" alt="Virtual only Card preview" *ngIf="virtualOnlyCardPreviewUrl" [src]="virtualOnlyCardPreviewUrl">
        </div>



      </mat-card-content>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Appearance</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>


        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsAppearance ">
          <app-content-row [field]="field" [entity]="product"></app-content-row>
        </div>

      </mat-card-content>
    </mat-card>


    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Annual fee Deduction, Invoicing and Collection</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsAnnualFeeOptions ">
          <app-content-row [field]="field" [entity]="product"></app-content-row>
        </div>
      </mat-card-content>

    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Cashback</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCashback ">
          <label fxFlex="35" class="secondary">{{ field.header }}</label>
          <label fxFlex="65" *ngIf="product">{{ field.cell(product) }}</label>
        </div>
      </mat-card-content>

    </mat-card>


    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>App Settings</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsApps">
          <label fxFlex="35" class="secondary">{{ field.header }}</label>
          <label fxFlex="65" *ngIf="product">{{ field.cell(product) }}</label>
        </div>
      </mat-card-content>

    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Product Limits</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsProductLimits ">
          <label fxFlex="35" class="secondary">{{ field.header }}</label>
          <label fxFlex="65" *ngIf="product">{{ field.cell(product) }}</label>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Card Creation</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCardCreation ">
          <label fxFlex="35" class="secondary">{{ field.header }}</label>
          <label fxFlex="65" *ngIf="product">{{ field.cell(product) }}</label>
        </div>
      </mat-card-content>
    </mat-card>

  </div>

  <div fxFlex="50" fxFlex.md="50" fxFlex.sm="100">

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Loads</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsLoads ">
          <app-content-row [field]="field" [entity]="product"></app-content-row>
        </div>
      </mat-card-content>

    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Fees</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsFees ">
          <app-content-row [field]="field" [entity]="product"></app-content-row>
        </div>
      </mat-card-content>

    </mat-card>

    <app-event-log-view [logs]="logs" *ngIf="showLogs()"></app-event-log-view>

  </div>

</div>



<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <a mat-raised-button color="basic" (click)="returnBack()" style="margin-right: 10px;">Back</a>
  </div>
  <div fxFlex="50" class="text-right">
    <a mat-raised-button color="primary" routerLink="edit" *ngIf="isAdmin()">
      <mat-icon>edit</mat-icon>
      Edit
    </a>
  </div>
</div>
